import { _ } from 'core-js';
import Vue from 'vue'
import utils from "./utils";

export default {
    data: function () {
        return {}
    },
    methods: {
        toggle_sim_details_sidebar: async function (sim) {
            if(this.$store.state.show_sim_details_popup){
                Vue.set(this.$store.state.core,"current_sim_details",null);
                Vue.set(this.$store.state,"show_sim_details_popup",false);
            }else{
                Vue.set(this.$store.state.core,"current_sim_details",sim);
                Vue.set(this.$store.state,"show_sim_details_popup",true);
            }
        },

        toggle_current_sim_details_sidebar(){
            if(_.isNil(this.$store.state.core.subscriber)){
                return;
            }
            this.toggle_sim_details_sidebar(this.$store.state.core.subscriber.infos);
        }
        
    }
};